import { render, staticRenderFns } from "./LotSummary.vue?vue&type=template&id=3549d79f&"
import script from "./LotSummary.vue?vue&type=script&lang=js&"
export * from "./LotSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports